import React from "react";
import { useParams } from "react-router-dom";
import Header from "../components/Header";
import LiveTrackingView from "../components/LiveTrackingView";

export default function VesselDetail() {
    const { id } = useParams();
    return (
        <div className="min-h-screen">
            <Header />
            <main className="max-w-[1600px] mx-auto px-5 py-6">
                <LiveTrackingView vesselId={id} />
            </main>
        </div>
    );
}
